// extracted by mini-css-extract-plugin
module.exports = {"quote":"reviews_quote__7h3uV","header":"reviews_header__P9cF7","item":"reviews_item__ifPq_","a":"reviews_a__EW43g"};